<template>
  <v-navigation-drawer
    :value="value"
    fixed
    right
    temporary
    width="780"
    class="documents-drawer"
    overlay-opacity="0.65"
    @input="$emit('input', $event)"
  >
    <documents-company-detail
      ref="detail"
      :is-drawer="true"
      :loading="loading"
      :payload="payload"
      :downloading-sha="downloadingSha"
      :downloading-operation="downloadingOperation"
      :zipping-kyc="zippingKyc"
      :zipping-operations="zippingOperations"
      @close="$emit('input', false)"
      @download-kyc="$emit('download-kyc', $event)"
      @download-operation="$emit('download-operation', $event)"
      @download-kyc-zip="$emit('download-kyc-zip')"
      @download-operations-zip="$emit('download-operations-zip')"
    />
  </v-navigation-drawer>
</template>

<script>
import DocumentsCompanyDetail from './DocumentsCompanyDetail.vue'

export default {
  name: 'DocumentsCompanyPanel',

  components: {
    DocumentsCompanyDetail,
  },

  props: {
    value:   { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    // The get-company-documents response, or null while it is being fetched.
    payload: { type: Object, default: null },
    downloadingSha:       { type: String, default: null },
    downloadingOperation: { type: Object, default: null },
    zippingKyc:           { type: Boolean, default: false },
    zippingOperations:    { type: Boolean, default: false },
  },

  emits: [
    'input',
    'download-kyc',
    'download-operation',
    'download-kyc-zip',
    'download-operations-zip',
  ],

  watch: {
    value (open) {
      if (open) {
        this.$refs.detail?.resetTab()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.documents-drawer {
  background: #121212 !important;
  border-left: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.8) !important;
}
</style>
